module.exports = __webpack_public_path__ + "img/pumpStation.7cd36266.svg";